export enum OccupationNotificationType {
  HigherCapacity = 'HigherCapacity',
  LowerCapacity = 'LowerCapacity',
}
